import React from 'react'
import styled from 'styled-components'
import { AlertVariant } from '../alert/context'
import { getAlertMessageColor, getBrightAlertColor } from '../alert-text'
import { Small } from '../typography'
import { AlertIcon } from '../icon/alert/alert-icon'
import { Flex } from '../containers/flex'

type AlertBannerProps = {
  variant: AlertVariant
  title?: string
  message: string | React.ReactNode
  children?: React.ReactNode
}
const StyledAlertBanner = styled.div<{
  $variant: AlertVariant
}>`
  overflow: hidden;
  border: solid ${({ theme }) => theme.color.grey30};
  border-radius: ${({ theme }) => theme.space.s4};
  border-width: 1px;
  margin: ${({ theme }) => theme.space.s16} 0;
  padding: ${({ theme }) => theme.space.s8} ${({ theme }) => theme.space.s16}
    ${({ theme }) => theme.space.s8} ${({ theme }) => theme.space.s20};
  border-left: solid ${({ theme }) => theme.space.s4}
    ${({ theme, $variant }) => theme.color[getBrightAlertColor($variant)]};
  block-size: fit-content;
`

export const AlertBanner = ({
  variant,
  title,
  message,
  children,
}: AlertBannerProps) => {
  return (
    <StyledAlertBanner $variant={variant}>
      <Flex flexDirection="row" alignItems="center">
        <AlertIcon variant={variant} />
        <Flex flexDirection="column" justifyContent="center">
          {title && (
            <Small
              fontWeight={600}
              color={getAlertMessageColor(variant)}
              style={{ marginBottom: '0' }}
            >
              {title}
            </Small>
          )}
          <Small color="grey90" pr="s8">
            {message}
          </Small>
        </Flex>
        {children}
      </Flex>
    </StyledAlertBanner>
  )
}
